import React from 'react';
import { Typography } from 'housecall-ui';

import { Cart } from '../components/Cart/Cart';
import { Layout } from '../components/Layout';
import { StepProgressBar } from '../components/StepProgressBar';
import { SubCategoryList } from '../components/SubCategoryList';
import { useChangeStep } from '../hooks/useChangeStep';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

import { BackArrowButton } from './BackArrowButton';

export const SubCategoryStep = () => {
  const {
    state: { industry, category, firstStepSkipped },
  } = useOnlineBookingReducer();
  const { changeStep } = useChangeStep();

  const handleBackClick = () => {
    changeStep('categories');
  };

  return (
    <Layout
      ContentComponent={
        <>
          {!firstStepSkipped ? <BackArrowButton onClick={handleBackClick} /> : null}
          <Typography gutterBottom variant="h5">
            What can we do for you?
          </Typography>
          <Typography gutterBottom variant="subtitle1">
            {industry?.name} / {category?.name}
          </Typography>
          <SubCategoryList />
        </>
      }
      Header={
        <>
          <StepProgressBar currentStep={1} stepCount={5} />
          <Cart />
        </>
      }
    />
  );
};

SubCategoryStep.hiddenButtons = true;
